<div class="flex flex-col flex-auto mt-8 bg-card shadow rounded-2xl overflow-hidden">
    <div class="flex items-start justify-between m-6 mb-0">
        <div class="text-xl font-medium tracking-tight leading-6 truncate">Val. media Premoney per giorno
        </div>
    </div>
    <div class="flex items-start mt-6 mx-6">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-12">
            <div class="flex flex-col">
                <div class="flex items-center">
                    <div class="font-medium text-secondary leading-5">Media complessiva</div>
                    <mat-icon
                            class="ml-1.5 icon-size-4 text-hint"
                            [svgIcon]="'heroicons_solid:information-circle'"
                            [matTooltip]="'Score is calculated by using the historical ratio between Page Views and Visitors. Best score is 1000, worst score is 0.'"></mat-icon>
                </div>
                <div class="flex items-start mt-2">
                    <div class="text-xl font-bold tracking-tight leading-none">{{appForPremoney?.avgVal?.totalAvg | number: '1.0-0'}}
                        €
                    </div>
                    <!--                                    <div class="flex items-center ml-2">-->
                    <!--                                        <mat-icon-->
                    <!--                                                class="icon-size-5 text-green-500"-->
                    <!--                                                [svgIcon]="'heroicons_solid:arrow-circle-up'"></mat-icon>-->
                    <!--                                        <div class="ml-1 text-md font-medium text-green-500">42.9%</div>-->
                    <!--                                    </div>-->
                </div>
            </div>
            <div class="flex flex-col">
                <div class="flex items-center">
                    <div class="font-medium text-secondary leading-5">Valor. massima</div>
                    <mat-icon
                            class="ml-1.5 icon-size-4 text-hint"
                            [svgIcon]="'heroicons_solid:information-circle'"
                            [matTooltip]="'Average Ratio is the average ratio between Page Views and Visitors'"></mat-icon>
                </div>
                <div class="flex items-start mt-2">
                    <div class="text-xl font-bold tracking-tight leading-none">{{appForPremoney?.avgVal?.maxVal | number: '1.0-0'}}
                        €
                    </div>
                    <!--                                    <div class="flex items-center ml-2">-->
                    <!--                                        <mat-icon-->
                    <!--                                                class="icon-size-5 text-red-500"-->
                    <!--                                                [svgIcon]="'heroicons_solid:arrow-circle-down'"></mat-icon>-->
                    <!--                                        <div class="ml-1 text-md font-medium text-red-500">13.1%</div>-->
                    <!--                                    </div>-->
                </div>
            </div>

        </div>
    </div>
    <div class="flex flex-col flex-auto h-100 mt-3">
        <app-dashboard-chart
                class="w-full h-full"
                [chartData]="premoneyAvgforDayData"></app-dashboard-chart>
    </div>
</div>
